import { getGPPData } from './api.js';

const getConsentState = async () => {
  let doNotSell = false;
  const gppData = await getGPPData();
  const supportedAPI = Object.values(gppData.parsedSections)[0];
  if (supportedAPI) {
    doNotSell = supportedAPI.SaleOptOut !== 2 || supportedAPI.Gpc;
  }
  return {
    doNotSell,
    signalStatus: gppData.signalStatus
  };
};

export { getConsentState };
